import { render, staticRenderFns } from "./contentEdit.vue?vue&type=template&id=6a4fe62a&scoped=true&"
import script from "./contentEdit.vue?vue&type=script&lang=js&"
export * from "./contentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fe62a",
  null
  
)

export default component.exports